// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__Ci9a4","footer_links":"Footer_footer_links__6cfhn","icons":"Footer_icons__lCS+A"};